import {useMount} from '@s-ui/react-hooks'
import SpinnerBasic, {spinnerBasicOverlayTypes} from '@adv-mt/mt-spinner-basic'

const Skeleton = () => {
  useMount(() => {
    window.scrollTo(0, 0)
  })
  return (
    <div className="mt-Detail-skeleton">
      <SpinnerBasic overlayType={spinnerBasicOverlayTypes.LIGHT} />
    </div>
  )
}

export default Skeleton
